<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة مدينة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/citiesview">المدن</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة مدينة</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center align-content-center mb-4 mt-5">
          <div class="col-12 col-md-8">
            <h5 class="text-brown me-2">
              <i class="bi bi-clipboard-plus pe-2 text-brown"></i>أضافة مدينة 
            </h5>
            <div class="card">
              <div class="text-center pt-3">
                <errorAlert v-if="hasError" :alertMessage= "message" />
              </div>
              <div v-if="successRegion" class="text-center pt-3">
                <successAlert :message="message" />
              </div>
              <div class="card-body">
                <form action="" @submit.prevent="citieCreate">
                  <div class="row">
                    <div class="col">
                      <label for="">المنطقة</label>
                      <select class="form-select" v-model="region_id">
                        <option v-for="(row,index) in rows" :key="index" :value="row.id">
                          {{ row.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">الاسم - عربي</label>
                      <input type="text" class="form-control" v-model="cityName">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الاسم - انجليزي</label>
                      <input type="text" class="form-control" v-model="nameEn">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">خط العرض (latitude)</label>
                      <input type="number" class="form-control" v-model="latitude" step="0.000001">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">خط الطول (longitude)</label>
                      <input type="number" class="form-control" v-model="longitude" step="0.000001">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">الصورة - عربي</label>
                      <input type="file" class="form-control" 
                      @change="onFileAdd($event.target.files)">
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الصورة - انجليزي</label>
                      <input type="file" class="form-control" 
                      @change="onFileAddEn($event.target.files)">
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col-12 col-sm-6">
                      <label for="">كود هيئة العقار:</label>
                      <input type="text" class="form-control" v-model="regaId" />
                    </div>
                    <div class="col-12 col-sm-6">
                      <label for="">الحاله</label>
                      <select class="form-control" v-model="status">
                        <option :value="true">نشط</option>
                        <option :value="false">غير نشط</option>
                      </select>
                    </div>
                  </div>
                  <div class="row py-2">
                    <div class="col text-center">
                      <loader v-if="isLoading" />
                      <button v-else type="submit" class="btn btn-success">إرسال</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>
<script>
export default {
  name:'citieAdd',
  data(){
    return {
      hasError: false,
      message: '',
      cityName: "",
      nameEn: "",
      isLoading: false,
      status: true,
      successRegion: false,
      longitude: "",
      latitude: "",
      rows:[],
      region_id: null,
      loader: false,
      coverimg: "",
      coverEn: null,
      regaId: null,
    }
  },
  methods:{
    resetData(){
      this.cityName = "";
      this.nameEn = "";
      this.longitude = "";
      this.latitude = "";
      this.region_id = null;
      this.coverimg = "";
      this.coverEn = null;
      this.regaId = null;
    },
    citieCreate(){
      this.hasError = false;
      this.successRegion = false;
      this.message = "";
      if(!this.region_id){
        this.message = 'يجب ادخل أسم المنطقة';
        this.hasError = true;
        window.scroll(0,0);
        return false;
      }
      if(this.cityName == ""){
        this.message = 'يجب ادخل أسم المدينة';
        this.hasError = true;
        window.scroll(0,0);
        return false;
      }
      if(this.nameEn == ""){
        this.message = 'يجب ادخل اسم المدينة باللغة الانجليزية';
        this.hasError = true;
        window.scroll(0,0);
        return false;
      }
      this.isLoading = true;
      const formData = new FormData();
      formData.append('regionId',this.region_id);
      formData.append('name',this.cityName);
      formData.append('nameEn',this.nameEn);
      formData.append('latitude',this.latitude);
      formData.append('longitude',this.longitude);
      formData.append('isActive',this.status);
      if(this.coverimg != '')
        formData.append('cover',this.coverimg);
      if(this.coverEn)
        formData.append('coverEn', this.coverEn);
      if(this.regaId)
        formData.append('regaId', this.regaId);

      this.$http.post("/api/admin/cities/create", formData).then(res => {
        this.resetData();
        this.isLoading = false;
        this.message = 'تم الاضافة بنجاح';
        this.successRegion = true;
        window.scroll(0,0);
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scroll(0,0);
      })
    },

    regionList() {
      this.hasError = false;
      this.loader = true;
      this.$http.get('/api/admin/regions/list').then(res => {
        this.loader = false;
        this.rows = res.data.regions;
        this.region_id = res.data.regions.id;
      }).catch(err => {
        this.message = this.$globalError(err);
        this.hasError = true;
        this.loader = false;
        window.scroll(0,0);
      })
    },
    onFileAdd(files){
      this.coverimg = files[0];
    },
    onFileAddEn(files){
      this.coverEn = files[0];
    },
  },
  created() {
    this.regionList();
  }
}
</script>
